<div class="external-box">
  <ngx-loading-bar [includeSpinner]="false" [color]="'#ff8c00'" [height]="'3px'"></ngx-loading-bar>
  <app-toast aria-live="polite" aria-atomic="true"></app-toast>
  <div class="container d-flex flex-column">
    <app-header [institution]='Institution.insieme'></app-header>
    <app-navbar [institution]='Institution.insieme'></app-navbar>
    <router-outlet class="mt-2 wrapper"></router-outlet>
    <app-footer [institution]='Institution.insieme'></app-footer>
  </div>
</div>
